import { render, staticRenderFns } from "./AppAccidentService.vue?vue&type=template&id=00549be8"
import script from "./AppAccidentService.vue?vue&type=script&lang=js"
export * from "./AppAccidentService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\nakatsukasa\\Herd\\cms.insag\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00549be8')) {
      api.createRecord('00549be8', component.options)
    } else {
      api.reload('00549be8', component.options)
    }
    module.hot.accept("./AppAccidentService.vue?vue&type=template&id=00549be8", function () {
      api.rerender('00549be8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/common/components/AppAccidentService.vue"
export default component.exports